import { IconButton } from "@chakra-ui/react";

import Icon from "src/icons";

const DragHandleIcon = ({ ...restProps }) => (
  <IconButton
    display="flex"
    variant="unstyled"
    aria-label="Drag Handle"
    icon={<Icon type="dragIndicator" />}
    {...restProps}
  />
);

export default DragHandleIcon;
export { default as DragHandle } from "./DragHandle";
